import {useState, useEffect} from "react"
import {Link} from "react-router-dom"
import "./navbar.css"
import 'bootstrap/dist/css/bootstrap.css';
import logo from "./logo_transparent.png"

import MenuDropdown from "./MenuDropdown";

interface Size {
  width: number;
  height: number;
}


function scrollToBottom() {
  window.scrollTo({
    top: 800,
    behavior: "smooth",
  })
}


function Navbar() {
  const [size, setSize] = useState<Size>();

  // This function updates the state thus re-render components
  const resizeHandler = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    setSize({
      width: width,
      height: height,
    });
  };

  // Listening for the window resize event
  useEffect(() => {
    window.onresize = resizeHandler;
  }, []);

  let width = window.innerWidth;
  // TODO: FotMM logo, Jobs Readiness, Resources, Success Stories, Check Eligibility
  //changed logo from <p> to <Link>
  if(width > 1150) {
    return (
    <nav id="navbar">
      <Link to="/" id="logo-new">
        <img src={logo} className="App-logo-2" alt="logo" />
      </Link>
      <ul>
        <li>
          <Link to="/check-eligibility" className="check-eligibility-button">
            Check Eligibility
          </Link>
        </li>
        <li>
          <Link to="/contact-us">Contact Us</Link>
        </li>
        <li>
          <Link to="/success-stories">Success Stories</Link>
        </li>
        <li>
          <Link to="/resources">Resources</Link>
        </li>
        {/*
        <li>
          <Link to="/jobs-readiness">Jobs Readiness</Link>
        </li>
        */}
        <div onClick={() => scrollToBottom()}>
        <li>
          <Link to="/">Programs</Link>

        </li>

        </div>
        <li>
          <Link to="/about-us">About Us</Link>
        </li>
      </ul>
    </nav>
  )} else {
    return (
      <div className="mobile-nav">
        <div>
        <Link to="/" id="logo">
          <img src={logo} className="App-logo-3" alt="logo" />
        </Link>
        <div className="actualCssForMenu">
          <MenuDropdown />
        </div>
        </div>
      </div>
     
    )
  }
}

export default Navbar